import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';

export class SurveyDispatchApi extends BaseApi {
    constructor(client, basePath = '/survey-dispatches') {
        super(client, basePath);
    }

    async getAll(params = {}) {
        try {
            const response = await this.client.get(this.basePath, { params });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async update(id, data) {
        try {
            const response = await this.client.patch(`${this.basePath}/${id}`, data);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async runNow(id) {
        try {
            const response = await this.client.post(`${this.basePath}/${id}/run-now`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
